import { JointCommissionCoefficientAdmin } from './../../../../admin/model/joint-commission-coefficient.model';
import {Pagination} from '../pagination.model';

export class JointCommissionCoefficientPage extends Pagination {
  content: JointCommissionCoefficientAdmin[] = [];
}
